module.exports = function setLocalStorageValue(key, value) {
    if (localStorage.getItem(key))  localStorage.removeItem(key);
    localStorage.setItem(key, value);
};
